// ==========================
// Version 1 - wallet/useLinkedWallet.js
// - Subscribes to the current user's linked wallet record
// ==========================
import React from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export function useLinkedWallet(uid) {
  const [state, setState] = React.useState({
    loading: !!uid,
    wallet: null,
    error: null,
  });

  React.useEffect(() => {
    if (!uid) {
      setState({ loading: false, wallet: null, error: null });
      return undefined;
    }

    setState((prev) => ({ ...prev, loading: true, error: null }));

    const ref = doc(db, "users", uid);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.exists() ? snap.data() : null;
        setState({
          loading: false,
          wallet: data?.wallet || null,
          error: null,
        });
      },
      (error) => {
        setState({
          loading: false,
          wallet: null,
          error,
        });
      }
    );

    return unsub;
  }, [uid]);

  return state;
}

// ==========================
// End Version 1 - wallet/useLinkedWallet.js
// ==========================
